import { FiList } from 'react-icons/fi';
import { ORDER_LIST_MOBILE_SORT_OPTIONS } from '../../../screens/order/common/orderListMobileSortOptions';
import { buildMobileIslandLeadItems, buildMobileIslandSearchConfig, buildMobileIslandSortAction, getMobileIslandSortMeta } from '../utils';

/** 订单列表页三岛配置（handlersRef 承载回调，避免 useMemo 依赖函数引用） */
export const buildOrderListMobileIslandConfig = ({
	pageTitle,
	appliedKeyword,
	handlersRef,
	scrollToTop,
	hasAdvancedFilters,
	filterBadge,
	filterAriaControls,
	currentSortLabel,
	isDefaultSort,
	sortOpen,
	hasExportExcel,
	isExportingExcel,
	exportExcelDisabled,
	hasBulkDelete,
	hasSelectedRows,
	selectedCount,
	isDeletingOrders,
	searchPlaceholder,
}) => ({
	id: 'order-list',
	leadItems: buildMobileIslandLeadItems({
		iconComponent: FiList,
		pageTitle,
		fallbackTitle: '订单查询',
		scrollToTop,
	}),
	actions: [
		{
			key: 'filter',
			icon: 'filter',
			label: '筛选',
			onClick: () => handlersRef.current.onOpenFilters(),
			active: hasAdvancedFilters,
			badge: filterBadge,
			ariaControls: filterAriaControls,
		},
		buildMobileIslandSortAction({
			handlersRef,
			currentSortLabel,
			isDefaultSort,
			sortOpen,
			sortAriaControls: 'orderListMobileSort',
		}),
		{
			key: 'export',
			icon: 'file-excel',
			label: '导出',
			onClick: () => handlersRef.current.onExportExcel?.(),
			hidden: !hasExportExcel,
			loading: isExportingExcel,
			disabled: exportExcelDisabled,
			tone: 'success',
		},
		{
			key: 'delete',
			icon: 'trash-alt',
			label: '删除',
			onClick: () => handlersRef.current.onDeleteSelected?.(),
			hidden: !hasBulkDelete,
			disabled: !hasSelectedRows || isDeletingOrders,
			loading: isDeletingOrders,
			badge: selectedCount > 0 ? selectedCount : 0,
			tone: 'danger',
		},
	],
	search: buildMobileIslandSearchConfig({
		inputId: 'orderListFilterKeyword',
		appliedKeyword,
		handlersRef,
		placeholder: searchPlaceholder,
	}),
});

export const getOrderListMobileIslandSortMeta = (table) =>
	getMobileIslandSortMeta(table, ORDER_LIST_MOBILE_SORT_OPTIONS);
